document.addEventListener("DOMContentLoaded", ()=>{
    const prodTabs = document.querySelectorAll('.product__product-info__tab-content-wrapper')
    const prodTogglers = document.querySelectorAll('.js-toggle-tab')
    prodTogglers.forEach(btn=>{
        btn.addEventListener('click', ()=>{
            prodTabs.forEach(tab=>tab.classList.add("hidden"))
            prodTogglers.forEach(tab=>tab.classList.remove("hidden"))

            const currentTab = document.querySelector(`.product__product-info__tab-content-wrapper#${btn.dataset.relatedTab}`)
            currentTab.classList.remove('hidden')
            btn.classList.add('hidden')
        })
    })
})